import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NOT_APPLICABLE } from '../../constants';
import { toDisplayTimeString } from '../../helpers/moment-ex';
import { DataTable } from '../widgets/DataTable';
import CommandAssignForm from '../Device/CommandAssignForm';
import HardwareInfo from './HardwareInfo';
import { LoadingStyle } from '../Hardware/utils';

const HardwareRow = (props) => {
    const { item, index, hardwareId, isRequesting, sensorsInfo } = props;

    const [openConsoleModal, setConsoleModal] = useState(false);

    const cpuIcon = require("../../../assets/images/ic_cpu.svg");

    const [modalInfo, setModalInfo] = useState({
        command: { show: false, deviceId: null, deviceName: "" },
        hardware: { show: false, hardwareId: null }
    });

    const Unavailable = <span className="un-available">{NOT_APPLICABLE}</span>;

    const formatFarmStatus = (farmItem, index) => {
        return <span key={index}
            className={`my-1 badge badge-pill ${farmItem.is_current_active_farm ? "badge-success" : "badge-secondary"} badge-sm mr-2`}>
            {farmItem.farm_name}
        </span>
    };

    const formatNetworkConnection = () => {
        if (!sensorsInfo) return Unavailable;
        if (sensorsInfo.qConnection.connected)
            return <span className="badge badge-pill badge-success badge-sm">Connected</span>;
        else if (sensorsInfo.qConnection.connected === false)
            return <span className="badge badge-pill badge-danger badge-sm">Disconnected</span>;
        else return Unavailable;
    };

    const formatNetworkLinkUptime = () => {
        if (!sensorsInfo) return Unavailable;
        const upTime = (sensorsInfo.qConnection.upTime !== null) ?
            toDisplayTimeString(sensorsInfo.qConnection.upTime) : null;

        if (sensorsInfo.qConnection.connected)
            return <span>{upTime} <i className="fa fa-arrow-up" style={{ fontSize: '12px', color: 'green' }} /></span>;
        else if (sensorsInfo.qConnection.connected === false)
            return <span>{upTime} <i className="fa fa-arrow-down" style={{ fontSize: '12px', color: 'red' }} /></span>;
        else return Unavailable;
    };

    const formatCanConnection = () => {
        if (!sensorsInfo) return Unavailable;
        const status = sensorsInfo.canConnection.state;

        if (status === 1)
            return <span className="badge badge-pill badge-danger badge-sm">Disconnected</span>;
        else if (status === 2)
            return <span className="badge badge-pill badge-warning badge-sm">Needs Attention</span>;
        else if (status === 3)
            return <span className="badge badge-pill badge-success badge-sm">Connected</span>;
        else return Unavailable;
    };

    const formatBatteryInfo = () => {
        let batteryText = "";
        if (!sensorsInfo) return batteryText;
        const { state, percent } = sensorsInfo.battery;

        if (percent !== null) batteryText = `${percent}%`;
        if (state !== null) {
            let stateDesc = null;
            if (state === 1) stateDesc = "Charging";
            else if (state === 2) stateDesc = "Discharging";

            if (stateDesc) batteryText += batteryText ? ` (${stateDesc})` : stateDesc;
        }
        return batteryText;
    };

    const handleCommandModal = (type, show, id, name) => {
        setModalInfo({ ...modalInfo, [type]: { show, deviceId: id ? id : null, deviceName: name ? name : "" } });
    };

    return <>
        <DataTable.Row className={`item ${!item.is_active && "active"}`}>
            <DataTable.Cell style={{ width: "30px", textAlign: "center" }}>{index}</DataTable.Cell>
            <DataTable.Cell style={{ width: "90px", textAlign: "start" }}>
                {item.hardware_name}
                {(item.current_hardware_info || {}).device_uuid &&
                    <span
                        className="float-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCommandModal("command", true, item.current_hardware_info ? item.current_hardware_info.device_uuid : null, item.hardware_name)}>
                        <img className="icon-cpu pr-1" src={cpuIcon} title="Send command" alt="Send command" />
                    </span>
                }

            </DataTable.Cell>
            <DataTable.Cell style={{ width: "90px", textAlign: "center" }}>{item.hardware_type_name}</DataTable.Cell>
            <DataTable.Cell style={{ width: "130px", textAlign: "start" }}>
                {item.farm_list.sort((a, b) => b.is_current_active_farm - a.is_current_active_farm)
                    .map((farmItem, i) => formatFarmStatus(farmItem, i))}
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "80px", textAlign: "start" }}>
                {item.current_hardware_info ? item.current_hardware_info.equipment_group_name : ""}
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "90px" }}>{(item.current_hardware_info && item.current_hardware_info.imei) || Unavailable}</DataTable.Cell>
            <DataTable.Cell style={{ width: "40px" }}>{(item.current_hardware_info && item.current_hardware_info.app_version) || Unavailable}</DataTable.Cell>
            <DataTable.Cell style={{ width: "70px", textAlign: 'center' }}>
                {isRequesting ? <LoadingStyle /> : formatNetworkConnection()}</DataTable.Cell>
            <DataTable.Cell style={{ width: "80px", textAlign: 'center' }}>
                {isRequesting ? <LoadingStyle /> : formatNetworkLinkUptime()}</DataTable.Cell>
            <DataTable.Cell style={{ width: "140px", textAlign: 'start' }}>
                {(item.current_hardware_info && item.current_hardware_info.can_code) ? item.current_hardware_info.can_code : Unavailable}
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "80px", textAlign: 'start' }}>
                {isRequesting ? <LoadingStyle /> : formatCanConnection()}</DataTable.Cell>
            <DataTable.Cell style={{ width: "90px", textAlign: 'center' }}>
                {isRequesting ? <LoadingStyle /> : formatBatteryInfo()}</DataTable.Cell>
            <DataTable.Cell style={{ width: "40px", textAlign: 'center' }}>
                <i className="fa fa-cogs" title="See Details" aria-hidden="true"
                    onClick={() => setConsoleModal(true)}></i>
            </DataTable.Cell>
        </DataTable.Row>
        {openConsoleModal &&
            <HardwareInfo
                show={true}
                onHide={() => setConsoleModal(false)}
                hardwareId={hardwareId}
                hardwareInfo={item}
            />}
        {modalInfo.command.deviceId &&
            <CommandAssignForm
                modalInfo={modalInfo.command}
                onHide={() => handleCommandModal("command", false)} />}
    </>
}

const mapStateToProps = (state, ownProps) => {
    const egId = ownProps.item && ownProps.item.current_hardware_info ? ownProps.item.current_hardware_info.equipment_group_uuid : null
    return ({
        isRequesting: state.hardware.sensorListById.isRequesting,
        sensorsInfo: egId && state.hardware.sensorListById.payload[egId] ?
            state.hardware.sensorListById.payload[egId] : null
    })
};

export default connect(mapStateToProps)(HardwareRow);